// ------ actions
export const ACTION_AUTH_LOGOUT = 'ACTION_AUTH_LOGOUT';

export const ACTION_AUTH_SUCCESSFUL = 'ACTION_AUTH_SUCCESSFUL';

export const ACTION_AUTH_REFRESH_SUCCESSFUL = 'ACTION_AUTH_REFRESH_SUCCESSFUL';


// ------ auth events
export const EVENT_AUTH_LOGOUT = 'onAuthLogout';

export const EVENT_AUTH_REFRESH_ERROR = 'onAuthRefreshError';

export const EVENT_AUTH_REFRESH_SUCCESS = 'onAuthRefreshSuccess';

export const EVENT_AUTH_SUCCESS = 'onAuthSuccess';



// ------ nav paths
export const NAV_LOGIN = '/sign-in';

export const NAV_LOGOUT = '/sign-out';



// ------ roles
export const ROLE_FEATURE_CART = 'feature-cart';
export const ROLE_FEATURE_ORDER_SUBMISSION = 'feature-order-submission';
export const ROLE_FEATURE_SEARCH = 'feature-search';
